/**
 *  Filename ....: add-catalogues.component.ts
 *  Created by ..: ianday
 *  on Date .....: 3/16/23
 **/
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Catalogues} from '../../../../../models/catalogues';
import {SitesService} from '../../../../../services/sites.service';
import {DwUtils} from '../../../../../components/utils/dw-utils';
import {ValidationResult} from '../../../../../models/validation-result';

@Component({
    selector: 'app-add-catalogues',
    templateUrl: './add-catalogues.component.html',
    styleUrls: ['./add-catalogues.component.css']
})

export class AddCataloguesComponent implements OnInit {

    public record: Catalogues;
    public _parentId: number;
    public id = 0;
    public handle = '';
    public description = '';
    public defaultFlag = 0;
    public visibility = 0;
    public activeStatus = '';
    public sitesService: SitesService;
    public strErr = '';
    public addEditFlag: boolean;

    @Output() cancelAddCatalogues = new EventEmitter();
    @Output() submitAddCatalogues = new EventEmitter<Catalogues>();

    @Input() set parentId(value: number) {
        this._parentId = value;
    }

    get parentId(): number {
        return this._parentId;
    }

    constructor(ssvc: SitesService) {
        this.sitesService = ssvc;
    }

    ngOnInit() {

    }
    initializeRecord(c: Catalogues): void {

        this.id = c.id;
        this.handle = c.handle;
        this.description = c.description;
        this.defaultFlag = c.defaultFlag;
        this.visibility = c.visibility;
        this.activeStatus = c.activeStatus;
    }
    afterOpenDialog(inputRec: Catalogues, aeFlag: boolean): void
    {
        this.addEditFlag = aeFlag;
        if(aeFlag === true) {
            inputRec.activeStatus = 'Active';
        }
        this.initializeRecord(inputRec);

        setTimeout(() => {
            DwUtils.setFocus('cataloguesHandle');
        }, 300);

    }
    doCancel() {
        this.cancelAddCatalogues.emit();
    }
    setRecord(): void {
        this.record = new Catalogues();
        this.record.id = this.id;
        this.record.siteId = this.parentId;
        this.record.handle = DwUtils.capitalize(this.handle).trim();
        this.record.defaultFlag = this.defaultFlag;
        this.record.visibility = this.visibility;
        this.record.description = this.description.trim();
        this.record.activeStatus = this.activeStatus;

    }
    doSubmit() {
        // this is where we stuff the new address and emit it back.
        this.setRecord();

        this.strErr = '';
        const vr: ValidationResult = this.record.validateRecord();

        if (vr.error.length > 0) {
            this.strErr = vr.error;
            DwUtils.setFocus(vr.focus_field);
            return;
        }
        // add the record ...
        if (this.addEditFlag === true) {
            this.sitesService.createCatalogues(this.record).subscribe(
                (data) => {
                    this.record.id = data.id;        // get the Id ...
                    this.submitAddCatalogues.emit(this.record);
                },
                (error) => {
                    this.strErr = 'Unable to create / save this record ';
                    return;
                });
        }
        else {
            this.sitesService.updateCatalogues(this.record).subscribe(
                (data) => {
                    this.submitAddCatalogues.emit(this.record);
                },
                (error) => {
                    this.strErr = 'Unable to update this record ';
                    return;
                });
        }
    }
}


